import React from "react";

export default function ChipButton({img, icon, label, onClick, selected, title}) {
    return (

    <div className={"chip-button" + (selected ? " selected" : "")} onClick={onClick} title={title} style={{marginBottom: "15px"}}>{icon}{label}</div>
    )
}